import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import { Link } from 'react-router';
import classNames from 'classnames';

import { Icon } from '@tcc/crate';

const baseString = 'vra-create-prescription-trigger';
var classString = classNames({
  [`${baseString}`]: true
});
const CreatePrescriptionTrigger = ({
  linkToCreateRoute,
  onClickCreatePrescriptionTrigger
}) => (
  <section className={classString}>
    <Link
      data-test-id='create-new-prescription'
      onClick={onClickCreatePrescriptionTrigger}
      to={linkToCreateRoute}>
      <Icon className={`${baseString}__add-icon`} glyph={Icon.set.ADD} />
      {getMessage('link-text__create-script')}
    </Link>
  </section>
);
CreatePrescriptionTrigger.propTypes = {
  linkToCreateRoute: PropTypes.string.isRequired,
  onClickCreatePrescriptionTrigger: PropTypes.func.isRequired
};
export default CreatePrescriptionTrigger;
